import React from "react";
import { AppRoutes } from "./routes/paths";

import "./App.css";

function App() {
  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
